import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';

export var WidgetCustomIFrame: Widget = {
    type: 'customContentIframe',
    id: '1',
    name: 'iFrame',
    position: DefaultWidgetPosition,
    label: {
        titleText: 'iFrame',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
    },
};
